import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

const NotFound = () => {
  return (
    <Container sx={{ height: '100%' }}>
      <Box
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%' }}
      >
        <Box flexDirection="column" justifyContent="center" alignItems="center">
          <Typography sx={{ mt: 2 }} variant="h4" color="error">
            404
          </Typography>
          <Divider variant="middle" />
          <Typography variant="h4" mb={4}>
            Unfortunately, the page you are looking for was not found!
          </Typography>
          <Button href="/">Go Back to Home</Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
